import React, { Fragment } from 'react'


const LayoutEmpty = (props) => {
  return <Fragment>{props.children}</Fragment>
}

export default LayoutEmpty